import { useCallback, useContext } from 'react';
import { useAuth } from 'react-oidc-context';
import { AppAuthProviderContext } from '../components';
import { clearLocalStorage } from '../utils';

type AppType = 'sr' | 'compliance' | 'selector';

export const useLogout = ({
  onRemoveQueries,
}: { onRemoveQueries?: () => void; appType?: AppType } = {}) => {
  const auth = useAuth();
  const { preservedLocalStorageKeys } = useContext(AppAuthProviderContext);

  return useCallback(
    async (redirectUrl?: string) => {
      const postLogoutRedirectUri =
        redirectUrl || import.meta.env.VITE_APP_SELECTOR_URL || auth.settings.redirect_uri;

      onRemoveQueries && onRemoveQueries();
      clearLocalStorage([...preservedLocalStorageKeys]);
      sessionStorage.clear();

      try {
        await auth.removeUser();
      } catch (error) {
        console.warn('[auth] Failed to remove local user during logout:', error);
      }

      try {
        console.log('postLogoutRedirectUri', postLogoutRedirectUri);
        await auth.signoutRedirect({
          post_logout_redirect_uri: postLogoutRedirectUri,
        });
      } catch (error) {
        console.warn('[auth] Logout redirect failed, falling back to local redirect:', error);
        window.location.replace(postLogoutRedirectUri);
      }
    },
    [auth, onRemoveQueries, preservedLocalStorageKeys],
  );
};
